<template>
  <page
    v-if="inited"
    :custom-style="{
      'padding-top': '0px',
      'background-color': '#F5F5F5',
      'min-height': '100vh'
    }"
  >
    <!-- 导航 -->
    <maple-nav-bar
      v-if="showNavBar"
      class="nav-bar"
      :background="navBackground"
      left-arrow
      left-arrow-color="#fff"
      :safe-top-distance="statusBarHeight"
      @click-left="$back"
    >
      <img
        slot="center"
        src="@/images/coupon_center/nav_title.png"
        width="80px"
      />
      <div slot="right" class="mine-coupon" @click="goMineCoupon">
        我的优惠劵
      </div>
    </maple-nav-bar>
    <!-- 广告位 -->
    <template v-if="hasCouponBanner">
      <div
        class="banner-wrapper"
        :style="{
          backgroundImage: `url(${pic.imgUrl})`
        }"
        @click="goLinkUrl"
      >
        <div
          v-if="!showNavBar"
          class="mine-coupon-wechat"
          @click="goMineCoupon"
        >
          我的优惠劵
        </div>
        <div v-if="activityCouponList.length > 0" class="activity-coupon">
          <activity-coupon
            v-for="(item, index) in activityCouponList"
            :key="index"
            :coupon="item"
            :index="index"
            :url-id="urlId"
            :activity-id="activityIds"
            @updateCouponStatus="updateActivityCouponStatus"
          />
        </div>
      </div>
    </template>

    <div
      ref="couponContent"
      :class="['coupon-content', !pic ? 'no-pic' : '']"
      :style="{
        'padding-top': couponPaddingTop
      }"
    >
      <!-- 付费劵包 -->
      <template v-if="hasCouponPack">
        <coupon-package
          :coupon-pack="couponPack"
          :url-id="urlId"
          :activity-id="activityIds"
        />
      </template>
      <!-- 充值 广告位 -->
      <recharge-banner
        v-if="showCard"
        :charge-ad="chargeAd"
        :url-id="urlId"
        :activity-id="activityIds"
        :has-coupon-pack="hasCouponPack"
      />
    </div>
    <div class="coupon-list-wrapper">
      <div
        v-if="showTabList"
        :class="[
          'sticky-tab-wrapper',
          {
            'no-subclass': !showSubClass,
            'no-navbar': !showNavBar
          }
        ]"
        :style="{
          top: !showNavBar ? '0' : 44 + statusBarHeight + 'px'
        }"
      >
        <!-- 优惠劵 筛选部分 -->
        <van-tabs
          v-model="tabActive"
          class="coupon-class-tab"
          color="#FF3900"
          title-active-color="#FF3900"
          title-inactive-color="#262626"
          line-width="18px"
          sticky
          @change="handleChangeTab"
        >
          <van-tab
            v-for="(item, index) in tabList"
            :key="index"
            :title="item.tabDesc"
            :name="index"
          >
          </van-tab>
        </van-tabs>
        <class-tab
          v-if="showSubClass"
          :sub-class-tab="subClassTab"
          @updateClassId="updateClassId"
        />
      </div>
      <div class="coupon-list" :style="{ minHeight: minHeight }">
        <template v-if="hasCouponList">
          <div v-for="(item, index) in list" :key="index">
            <!-- <single-product
            v-if="item.couponType == 6"
            :key="index"
            class="coupon-item"
            :index="index"
            :coupon="singleProduct"
          /> -->
            <coupon
              :key="index"
              class="coupon-item"
              :coupon="item"
              :index="index"
              @updateCouponStatus="updateCouponStatus"
            />
          </div>
          <div v-if="hasCouponList" class="tip">
            -<span>更多好劵，敬请期待</span>-
          </div>
        </template>
        <empty
          v-else-if="showTabList"
          desc="没有可领取的优惠券"
          :type="1"
          :img="'Coupon'"
          class="empty-box"
        />
      </div>
    </div>
    <empty
      v-if="!showTabList && !hasCouponList"
      desc="没有可领取的优惠券"
      :type="1"
      :img="'Coupon'"
      :class="[
        'empty-box',
        {
          'no-coupon': !showTabList && !hasCouponList
        }
      ]"
    />
  </page>
</template>

<script>
import { API } from '@/api'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import Empty from '@/common/layout/empty/index'
import Coupon from './components/coupon'
import CouponPackage from './components/CouponPackage'
import RechargeBanner from './components/RechargeBanner'
import ActivityCoupon from './components/ActivityCoupon'
// 单品劵遗留
// import SingleProduct from './components/singleProduct'
import ClassTab from './components/ClassTab'
import { NavBar } from '@mc/mc-jsbridge'
import { loginConfirm } from '@/utils/native_interactions/login'
import { miniProgramEnv } from '@/defines/environment'
import { cmsRedirect } from '@/common/cms/cms_redirect'
export default {
  components: {
    Coupon,
    Empty,
    CouponPackage,
    RechargeBanner,
    ActivityCoupon,
    ClassTab
    // SingleProduct
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = '领劵中心'
      const navBar = new NavBar(0)
      navBar.init()
      vm.init()
    })
  },
  data() {
    return {
      navBackground:
        'linear-gradient(90deg, rgba(255, 121, 84,1), rgba(255, 84, 35,1))',
      list: [],
      inited: false,
      couponPack: {},
      chargeAd: {
        ad: [],
        chargeDetail: {}
      },
      pic: {},
      activityCouponList: [],
      tabList: [],
      tabActive: 0,
      tabId: 0,
      class1Id: -1,
      classActive: 0,
      subClassTab: [],
      // 单品劵保留，下期遗留功能
      singleProduct: {}
    }
  },
  computed: {
    showNavBar() {
      return !miniProgramEnv.isMiniProgram
    },
    pagePaddingTop() {
      return '0px'
    },
    hasCouponPack() {
      return !!this.couponPack?.listUrl
    },
    hasCouponBanner() {
      return this.pic?.imgUrl
    },
    hasCouponList() {
      return this.list.length > 0
    },
    minHeight() {
      const height =
        document.documentElement.clientHeight || document.body.clientHeight
      const paddingTop =
        this.subClassTab.length > 0 ? 132 : this.showTabList ? 88 : height
      return height - paddingTop + 'px'
    },
    showTabList() {
      return this.tabList.length > 1
    },
    showSubClass() {
      return this.subClassTab.length > 0
    },
    showCard() {
      return this.chargeAd?.chargeDetail?.desc
    },
    urlId() {
      return this.pic?.urlId || ''
    },
    activityIds() {
      return this.pic?.activityIds || ''
    },
    couponPaddingTop() {
      if (!this.pic) {
        if (!this.showNavBar) {
          return 12 + 'px'
        }
        return this.statusBarHeight + 56 + 'px'
      } else {
        return 12 + 'px'
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.pageScroll)
  },
  beforeDestroy() {
    if (this.bannerOb) {
      this.bannerOb.disconnect()
      this.bannerOb = null
    }
    window.removeEventListener('scroll', this.pageScroll)
  },
  methods: {
    init() {
      this.initActivityCoupon()
      this.getCouponTab()
    },
    async initActivityCoupon() {
      this.$Loading()
      try {
        const res = await API.coupon.centerTop()
        this.chargeAd = res?.chargeAd
        this.activityCouponList = res?.pic?.coupons || []
        this.pic = res?.pic
        this.couponPack = res?.couponPack
        this.navBackground = this.pic?.imgUrl
          ? 'linear-gradient(90deg, rgba(255, 121, 84,0), rgba(255, 84, 35,0))'
          : 'linear-gradient(90deg, rgba(255, 121, 84,1), rgba(255, 84, 35,1))'
        this.handlePageTrack()
      } catch (error) {
        this.$catch(error)
      }
      this.$Loading.hide()
    },
    async getCouponTab() {
      try {
        const res = await API.coupon.centerTabs()
        this.tabList = res || []
        this.tabId = this.tabList[this.tabActive]?.tab
        this.initCouponList(true)
      } catch (error) {
        if (
          error?.res?.error?.code === 1012002 ||
          error?.res?.error?.code === 2003 ||
          error?.res?.error?.code === 1013014
        ) {
          loginConfirm()
        } else {
          this.$catch(error)
        }
      }
      this.$Loading.hide()
    },
    handlePageTrack() {
      tracerVuePlugin.page('#/coupon_center', {
        cms_id: Number(this.pic?.urlId) || 0,
        activity_id: String(this.pic?.activityIds) || ''
      })
      this.tracerExposeAd()
    },
    tracerExposeAd() {
      if (!this.pic) return
      const { tickerInfo } = this.pic
      const { click } = tickerInfo

      const params = this.getAdTracerParams()
      tracerVuePlugin.request({
        spm: click.spm,
        type: 8,
        params,
        page_id: 3499
      })
    },
    goLinkUrl() {
      if (this.pic) {
        const { tickerInfo } = this.pic
        const { click } = tickerInfo
        const params = this.getAdTracerParams()
        this.$track(click.spm, params)
      }
      cmsRedirect(this.pic?.action)
    },
    getStrCouponId() {
      if (this.activityCouponList.length < 0) return ''
      const couponIds = []
      this.activityCouponList.forEach(item => {
        couponIds.push(item.activityId)
      })
      return couponIds.join(',')
    },

    getAdTracerParams() {
      const { urlId, tickerInfo } = this.pic
      const { data } = tickerInfo
      const params = Object.assign(data, {
        cms_id: Number(urlId) || 0,
        activity_id: String(this.pic?.activityIds) || '',
        is_coupon: this.activityCouponList.length > 0 ? 1 : 0,
        str_coupon_id: this.getStrCouponId()
      })
      return params
    },
    pageScroll() {
      if (this.$refs.couponContent) {
        let opacity = 1
        const boundingTop = this.$refs.couponContent.getBoundingClientRect().top
        if (boundingTop <= 0) opacity = 1
        if (boundingTop > 248) opacity = 0
        if (boundingTop > 0 && boundingTop < 248)
          opacity = 1 - Math.abs(boundingTop) / 248
        this.navBackground = `linear-gradient(90deg, rgba(255, 121, 84,${opacity}), rgba(255, 84, 35,${opacity}))`
      }
    },

    handleChangeTab(active) {
      // this.tabActive = active
      const currentTab = this.tabList[active]
      this.tabId = currentTab?.tab
      this.$track(this.$trackMap.couponCenter.tabClick, {
        voucher_classification: String(this.tabId) || ''
      })
      this.subClassTab = currentTab.subClass ? currentTab?.subClass : []
      if (this.subClassTab.length > 0) {
        this.class1Id = this.subClassTab[0]?.id
      }
      this.initCouponList(true)
    },

    /**
     * 获取优惠卷数据
     */
    async initCouponList(loading) {
      this.list = []
      loading && this.$Loading()
      const params = {
        tab: this.tabId || 0
      }
      // eslint-disable-next-line eqeqeq
      if (this.tabId == 2) {
        params.class1Id = this.class1Id
      }

      try {
        const res = await API.coupon.centerGetByTab(params)
        this.list = res.length > 0 ? res : []
      } catch (error) {
        this.$catch(error)
      }
      this.inited = true
      this.$Loading.hide()
    },
    updateClassId({ class1Id }) {
      this.class1Id = class1Id
      this.$track(this.$trackMap.couponCenter.classTabClick, {
        the_primary: String(this.class1Id) || ''
      })
      this.initCouponList(true)
    },
    /**
     * 更新优惠卷状态
     */
    updateCouponStatus(data) {
      const { index, couponStatus, amount, remain, effectiveDesc } = data
      const newdata = Object.assign({}, this.list[index], {
        couponStatus,
        amount,
        remain,
        effectiveDesc
      })
      this.$set(this.list, index, newdata)
    },
    updateActivityCouponStatus(data) {
      const { index, couponStatus } = data
      const newdata = Object.assign({}, this.activityCouponList[index], {
        actionStatus: couponStatus
      })
      this.$set(this.activityCouponList, index, newdata)
    },
    goMineCoupon() {
      this.$nativeRedirect(this.$nativeRoutes.myCoupons)
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-center {
  min-height: 100vh;

  background-color: #f5f5f5;
}
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $z-navigation-bar;

  width: 100%;

  .mine-coupon {
    font-size: 0.24rem;
    color: #fff;
  }
}
.activity-coupon {
  display: flex;

  position: absolute;
  bottom: 0.48rem;
  left: 0.24rem;
}
.coupon-content {
  transform: translateY(-0.24rem);

  margin-bottom: -0.24rem;
  padding-top: 0.24rem;

  background-color: #f5f5f5;

  border-top-left-radius: 0.24rem;
  border-top-right-radius: 0.24rem;
  &.no-pic {
    transform: none;
  }
}
.banner-wrapper {
  position: relative;

  width: 100%;
  height: 4.96rem;

  background-repeat: no-repeat;
  background-size: contain;

  .mine-coupon-wechat {
    position: absolute;
    top: 0.24rem;
    right: 0.24rem;

    font-size: 0.24rem;
    color: #fff;
  }
}
.coupon-list-wrapper {
  margin-top: 0.24rem;
  .coupon-class-tab {
    background-color: #f5f5f5;
  }
  .sticky-tab-wrapper {
    position: -webkit-sticky;
    position: sticky;
    top: 44px;
    left: 0;
    z-index: 9;

    // height: 1.76rem;

    background-color: #f5f5f5;
    &.no-subclass {
      // height: 0.88rem;
      margin-bottom: 0.24rem;
    }
    &.no-navbar {
      top: 0px;
    }
  }
  .coupon-list {
    flex: auto;

    .coupon-item {
      margin: 0 0.24rem 0.24rem;
    }
    .tip {
      padding-top: 0.1rem;
      padding-bottom: 0.3rem;

      font-size: 0.24rem;
      text-align: center;
      color: #bfbfbf;
      & > span {
        margin: 0 0.08rem;
      }
    }
  }
}

.empty-box {
  position: relative;

  height: 100%;
  padding-top: 1.6rem;
  padding-bottom: 0.6rem;
}
</style>
